exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_form_container{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;margin:16px;margin-top:0;flex:80%}.modal_form_row{display:flex;flex-direction:row;flex:1;width:100%}.modal_form_input{opacity:.8;font-size:15px;font-weight:400;width:100%;height:32px;border-bottom:1px solid rgba(0,0,0,.07);font-family:Avenir-Roman;font-size:18px;color:#000;padding:4px}.modal_form_input_container{display:flex;flex-direction:column;flex:1;margin:4px}.modal_form_input_header{font-family:Avenir;font-size:14px;font-weight:500;opacity:.4;margin:4px}", ""]);

// exports
